import { useMemo } from "react";
import { useGetBudgetQuery, useGetBudgetsQuery } from "./budgetEndpoints";
import { Budget } from "../../entities/budget";

export function useBudget(budgetID: number | undefined) {
  const budgetQuery = useGetBudgetQuery(budgetID ?? 0, {
    skip: (budgetID ?? 0) <= 0,
  });
  const budgetEntity = budgetQuery.data;

  return useMemo(() => {
    const ret: typeof budgetQuery & { budget?: Budget | undefined } = {
      ...budgetQuery,
    };
    if (budgetEntity) ret.budget = new Budget(budgetEntity);
    return ret;
  }, [budgetQuery, budgetEntity]);
}

export function useBudgets() {
  const budgetQuery = useGetBudgetsQuery();
  const budgetEntitiesMap = budgetQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof budgetQuery & {
      budgets?: Budget[];
      budgetsMap?: { [id: number]: Budget };
    } = {
      ...budgetQuery,
      budgets: [],
      budgetsMap: {},
    };
    if (budgetEntitiesMap) {
      const budgets: Budget[] = [];
      const budgetsMap: { [id: number]: Budget } = {};

      for (const key in budgetEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(budgetEntitiesMap, key)) {
          const c = budgetEntitiesMap[key];
          const budget = new Budget(c);
          budgets.push(budget);
          budgetsMap[budget.id] = budget;
        }
      }
      ret.budgets = budgets;
      ret.budgetsMap = budgetsMap;
    }

    return ret;
  }, [budgetQuery, budgetEntitiesMap]);
}
